/**
 * SS Footer — behaviour layer for sections/ss-footer.liquid
 * Legacy footer scripts ported: analytics on contact/chat/store links,
 * mobile vs desktop destination for the floating store-locator button,
 * Popin video-call opener, hide floating helpers on the home page.
 * Accordions use the theme's <footer-accordion> element (footer-accordion.js).
 * No URLs, phone numbers or text live here — everything comes from the DOM.
 */
(function () {
  'use strict';

  if (customElements.get('ss-footer')) return;

  function track(eventName, label, extra) {
    try {
      if (typeof window.gaEvent === 'function') {
        window.gaEvent(eventName, [label || '', extra || '', '', '', '', ''], false);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push({ event: eventName, custom: { param_1: label || '', param_2: extra || '' } });
      }
    } catch (error) {
      /* analytics must never break the page */
    }
  }

  function isMobileUserAgent() {
    return /Mobi|Android/i.test(navigator.userAgent) || (window.matchMedia && window.matchMedia('(max-width: 749px)').matches);
  }

  class SsFooter extends HTMLElement {
    constructor() {
      super();
      this._listeners = [];
    }

    connectedCallback() {
      this.initTracking();
      this.initStoreLocator();
      this.initPopin();
      this.initFloatingVisibility();
    }

    disconnectedCallback() {
      this._listeners.forEach(([el, type, fn]) => el.removeEventListener(type, fn));
      this._listeners = [];
    }

    on(el, type, fn) {
      el.addEventListener(type, fn);
      this._listeners.push([el, type, fn]);
    }

    /* Click analytics for every [data-ss-track] element (menu links, contact, chat, floating) */
    initTracking() {
      this.on(this, 'click', (event) => {
        const el = event.target.closest('[data-ss-track]');
        if (!el || !this.contains(el)) return;
        track(el.dataset.ssTrack, el.dataset.trackLabel || el.textContent.trim().slice(0, 80), el.getAttribute('href') || '');
      });
    }

    /* Legacy: on phones the store locator opens the WhatsApp store request instead of the page */
    initStoreLocator() {
      const link = this.querySelector('#storeLocatorLink[data-mobile-href]');
      if (!link) return;
      const apply = () => {
        const desktopHref = link.dataset.desktopHref || link.getAttribute('href');
        link.dataset.desktopHref = desktopHref;
        if (isMobileUserAgent()) {
          link.setAttribute('href', link.dataset.mobileHref);
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener');
        } else {
          link.setAttribute('href', desktopHref);
          link.removeAttribute('target');
        }
      };
      apply();
      if (window.matchMedia) {
        const mql = window.matchMedia('(max-width: 749px)');
        const handler = () => apply();
        if (mql.addEventListener) {
          mql.addEventListener('change', handler);
          this._listeners.push([mql, 'change', handler]);
        }
      }
    }

    /* Popin video call — only when the vendor script exposes window.Popin / openPopinPopUp */
    initPopin() {
      this.querySelectorAll('[data-ss-popin]').forEach((button) => {
        const opener = typeof window.Popin === 'function' ? window.Popin : (typeof window.openPopinPopUp === 'function' ? window.openPopinPopUp : null);
        if (!opener) {
          const wrapper = button.closest('li, .popin-video-custom') || button;
          wrapper.hidden = true;
          return;
        }
        this.on(button, 'click', (event) => {
          event.preventDefault();
          let campaign = {};
          try { campaign = JSON.parse(button.dataset.popinCampaign || '{}'); } catch (error) { campaign = {}; }
          try {
            if (window.Popin === opener) opener('open', { groupId: button.dataset.popinGroup || '', campaign: campaign });
            else opener({ groupId: button.dataset.popinGroup || '', campaign: campaign });
          } catch (error) {
            console.warn('[ss-footer] Popin could not be opened', error);
          }
        });
      });
    }

    /* Hide floating helpers on the home page when the merchant asked for it */
    initFloatingVisibility() {
      const floating = this.querySelector('[data-ss-floating][data-hide-on-home="true"]');
      if (!floating) return;
      if (document.body.classList.contains('template-index')) floating.hidden = true;
    }
  }

  customElements.define('ss-footer', SsFooter);
})();
